import { themeQuartz, iconSetQuartzLight } from 'ag-grid-enterprise'

// to use myTheme in an application, pass it to the theme grid option
const agGridTheme = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: 'light',
  columnBorder: true,
  fontFamily: '"Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontSize: 12,
  foregroundColor: 'rgb(46, 55, 66)',
  headerBackgroundColor: '#F9FAFB',
  headerFontFamily: '"Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  headerFontSize: 10,
  headerFontWeight: 550,
  headerTextColor: '#1f1f1f',
  rowBorder: true,
  sidePanelBorder: true,
  sideBarPanelWidth: 200,
  cellHorizontalPadding: 8,
  headerHeight: 28,
  spacing: 2,
  textColor: 'rgba(0, 0, 0, 0.88)',
  wrapperBorder: true,
  wrapperBorderRadius: 8
})

export default agGridTheme
